import React, { useState } from "react";
import { useAppContext } from "../AppContext";
import ServerSettings from "./ServerSettings";
import ServerLicenses from "./ServerLicenses";
import { LicenseDataProvider } from "./LicenseDataProvider";
import Menubar from "../Menubar";
import AdvancedSettings from "./AdvancedSettings/AdvancedSettings";
import ServiceSiteComponent from "./components/ServerSiteComponent";
import { useParams } from "react-router-dom";
import { Tab, Tabs } from "@mui/material";

const ServerDetails = () => {
  const { serverUuid } = useParams();
  const { isAdmin } = useAppContext();
  const [allowUpdate, setAllowUpdate] = useState(false);
  const [currentTab, setCurrentTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setCurrentTab(newValue);
  };

  const tabs = [
    {
      label: "Server Licenses",
      component: (
        <LicenseDataProvider allowUpdate={allowUpdate}>
          <ServerLicenses></ServerLicenses>
          <AdvancedSettings />
        </LicenseDataProvider>
      ),
    },
    {
      label: "Cozify Settings",
      component: <ServiceSiteComponent serverUuid={serverUuid} />,
    },
  ];

  return (
    <div>
      <Menubar />
      <ServerSettings
        onAllowUpdate={(value) => setAllowUpdate(value)}
      ></ServerSettings>
      <Tabs
        value={currentTab}
        onChange={handleTabChange}
        aria-label="Server Details Tabs"
      >
        {tabs.map((tab, index) => (
          <Tab key={index} label={tab.label} value={index} />
        ))}
      </Tabs>
      <div style={{ marginTop: "20px" }}>{tabs[currentTab].component}</div>
    </div>
  );
};

export default ServerDetails;
